import moment from "moment";
import { FORMAT_DATE, SEARCH_OBJECT_MAX_SIZE } from "../../constants/moduleConsts";
import { ITimekeepingOverview } from "../models/timekeepingOverviewModels";

export const INIT_TIMEKEEPING_OVERVIEW: ITimekeepingOverview = {
  ...SEARCH_OBJECT_MAX_SIZE,
  nam: Number(moment().format(FORMAT_DATE.YYYY)),
  thang: Number(moment().format(FORMAT_DATE.MM)),
  tableTimesheet: []
}

export enum TYPE_TIMEKEEPING_SYNTHETIC {
  DI_LAM = "DI_LAM",
  NGHI = "NGHI",
  DI_HOC = "DI_HOC",
  TRUC = "TRUC",
  NGHI_BU = "NGHI_BU",
  OM = "OM",
  PHEP = "PHEP",
  CHE_DO_BAO_HIEM = "CHE_DO_BAO_HIEM",
  CHE_DO_HUONG_LUONG = "CHE_DO_HUONG_LUONG",
};